import { STATUS_ACTIVE, STATUS_INACTIVE } from 'constants/activeStatus';

export const getActiveStatusValue = (isActivated) =>
  isActivated ? STATUS_ACTIVE : STATUS_INACTIVE;

export const getIsActive = (status) => status === STATUS_ACTIVE;
